import React from 'react';
import { ListItem, ListItemText, ListItemAvatar, Avatar, Typography, Box, IconButton, Chip } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, ContentCopy as CloneIcon } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';
import { format } from 'date-fns';

function BookListItem({ book, userCurrency, onEdit, onDelete, onClone, getImageUrl }) {
  const { t } = useTranslation();

  const formatDate = (date) => {
    if (!date) return '';
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return '';
    return format(dateObj, 'yyyy/MM/dd');
  };

  return (
    <ListItem
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        mb: 1,
        bgcolor: 'background.paper',
        '&:hover': {
          bgcolor: 'action.hover'
        }
      }}
    >
      <ListItemAvatar>
        <Avatar
          variant="rounded"
          src={getImageUrl(book.imageUrl, book.title)}
          sx={{ width: 60, height: 80 }}
        />
      </ListItemAvatar>
      
      <ListItemText
        primary={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {book.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              by {book.author}
            </Typography>
            {book.series && (
              <Typography variant="body2" color="primary.main" sx={{ fontStyle: 'italic' }}>
                • {book.series}
              </Typography>
            )}
          </Box>
        }
        secondary={
          <Box>
            <Box sx={{ display: 'flex', gap: 1, mb: 1, flexWrap: 'wrap' }}>
              {book.publisher && (
                <Chip label={book.publisher} size="small" />
              )}
              {book.genre && (
                <Chip label={book.genre} size="small" variant="outlined" />
              )}
              {book.type && (
                <Chip label={book.type} size="small" variant="outlined" />
              )}
            </Box>
            <Typography variant="body2" color="text.secondary">
              {book.isbn && `ISBN: ${book.isbn} • `}
              {t('common.quantity')}: {book.qty || 1} • 
              Price: {userCurrency} {Math.round(book.price || 0).toLocaleString()} • 
              Added: {formatDate(book.createdDate)}
            </Typography>
          </Box>
        }
      />
      
      <Box sx={{ display: 'flex', gap: 1 }}>
        <IconButton
          size="small"
          onClick={() => onClone(book)}
          title={t('common.clone')}
        >
          <CloneIcon fontSize="small" color="info" />
        </IconButton>
        <IconButton
          size="small"
          onClick={() => onEdit(book.id)}
        >
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          onClick={() => onDelete(book)}
        >
          <DeleteIcon fontSize="small" color="error" />
        </IconButton>
      </Box>
    </ListItem>
  );
}

export default BookListItem; 